import { createActionThunk } from "redux-thunk-actions";

import {
  deletePostService,
  doArchiveService,
  editForum,
  getArchiveList,
  getList,
  langList as langListService,
  likedActService,
  loadMorePost,
  removeSaveService,
  shareForum,
  singlePostGet,
} from "../services/ForumService";
import {
  CLEAR_FORUM,
  FORUM_ARCHIVE_INITIALIZATION,
  FORUM_CANCEL_POST,
  FORUM_DELETE_POST,
  FORUM_DO_ARCHIVE,
  FORUM_INITIALIZATION,
  FORUM_INSERT,
  FORUM_LOAD_MORE,
  FORUM_ON_CHANGE_STATE,
  FORUM_RELEVANT,
  FORUM_REMOVE_ARCHIVE,
  FORUM_SELECT_FOR_EDIT_POST,
  FORUM_SINGLE_INITIALIZATION,
  ON_CHANGE_ARCHIVE_FILTERS,
  ON_CHANGE_FORUM_FILTERS,
  RE_GET_FORUM_FILTERS,
  ON_SEARCH_POSTS,
  getStarted,
  getSucceeded,
  getEnded,
} from './constant';
import { getdetailStocks } from '../services/StockService';
import { shouldHidePost } from '../lib/helper';
let typingTimeout = null;
const forumInitialization = createActionThunk(
  FORUM_INITIALIZATION,
  async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    let stocks = await getdetailStocks();
    let symptomsList =
      stocks.usersymptomforum && stocks.usersymptomforum.length > 0
        ? stocks.usersymptomforum.map((item, index) => {
          return { value: item._id, label: item.name };
        })
        : "";
    let data =
      stocks.usersymptomforum && stocks.usersymptomforum.length > 0
        ? await getList(
          stocks.usersymptomforum[0]._id,
          "",
          "",
          "",
          0,
          user.lang
        )
        : await getList("", "", "", "", 0, user.lang);
    let langList = await langListService();
    data.data = data.data.filter(
      (post) =>
        (!post.draft ||
          (post.draft && post.publish_status === "republishing")) &&
        post.publish_status !== "irelevant" &&
        !shouldHidePost(post)
    );
    return {
      symptomsList,
      data,
      symptomId:
        stocks.usersymptomforum && stocks.usersymptomforum.length > 0
          ? stocks.usersymptomforum[0]._id
          : "",
      langList,
      userLang: user.lang,
    };
  }
);
const forumMeInitialization = createActionThunk(
  FORUM_INITIALIZATION,
  async (userId, showDraft = "", pageMode, symptomId = "") => {
    let forumSymptom = localStorage.getItem("forumSymptom");
    if (forumSymptom) {
      localStorage.removeItem("forumSymptom");
    } else {
      forumSymptom = "";
    }
    let stocks = await getdetailStocks();
    let symptomsList = stocks.usersymptomforum.map((item, index) => {
      return { value: item._id, label: item.name };
    });
    if (symptomId === "" && pageMode === "user") {
      symptomId =
        stocks.usersymptomforum && stocks.usersymptomforum.length > 0
          ? stocks.usersymptomforum[0]._id
          : "";
    }
    let user = JSON.parse(localStorage.getItem("user"));
    let data = await getList(
      symptomId,
      "Most Resent",
      "",
      userId,
      showDraft,
      ""
    );
    return { symptomsList, data, symptomId, pageMode, pageName: "forumMe" };
  }
);
const forumArchiveInitialization = createActionThunk(
  FORUM_ARCHIVE_INITIALIZATION,
  async (user, id) => {
    let postData = "";
    let userLang = "";
    let langList = await langListService();
    let stocks = await getdetailStocks();
    let symptomsList =
      stocks.usersymptomforum && stocks.usersymptomforum.length > 0
        ? stocks.usersymptomforum.map((item, index) => {
          return { value: item._id, label: item.name };
        })
        : "";
    let data = await getArchiveList();
    return { data, symptomsList, langList, userLang: user.lang, singlePostId: id };
  }
);

const insertForum = createActionThunk(
  FORUM_INSERT,
  async (inputs, linksToNewPostItems, draft = false) => {
    let post = await shareForum(inputs, linksToNewPostItems, draft);
    return post;
  }
);

const onChangeFilters = createActionThunk(
  ON_CHANGE_FORUM_FILTERS,
  async (
    eventIn,
    filters,
    userId = undefined,
    draft = false,
    pageMode = false,
    pageName = '',
  ) => {
    let user = JSON.parse(localStorage.getItem('user'));
    var name = eventIn.target ? eventIn.target.name : eventIn.name;
    var value = eventIn.target ? eventIn.target.value : eventIn.value;
    let data = null;
    if (pageMode && pageMode == 'user') {
      if (name == 'symptom') {
        filters.search = '';
        filters.sortBy = 'Most Recent';
        filters.lang = "";
      }
    } else {
      if (name == 'symptom') {
        filters.search = '';
        filters.sortBy = 'Most Recent';
        filters.lang = user.lang;
      }
    }

    if (name != 'body' && pageMode && pageMode == 'mine') {
      filters.lang = "";
    }
    if (name != 'search' && name != 'body') {
      filters[name] = value;
      data = await getList(
        filters.symptom,
        filters.sortBy,
        filters.search,
        userId,
        draft,
        filters.lang,
      );
    }
    if (pageMode != 'mine' && data != null) {
      data.data = data.data.filter(
        (post) =>
          (!post.draft ||
            (post.draft && post.publish_status == 'republishing')) &&
          post.publish_status != 'irelevant' &&
          !shouldHidePost(post),
      );
    }

    return {
      name,
      value,
      data,
      pageName,
      userLang: user.lang,
      pageMode,
    };
  }
);
const reGetPosts = (filters, userId) => {
  return async (dispatch) => {
    let data = null;
    data = await getList(filters.symptom, filters.sortBy, undefined, userId);
    dispatch({
      type: RE_GET_FORUM_FILTERS,
      data,
    });
  };
};
const likedAct = createActionThunk(FORUM_RELEVANT, (postId, flag) =>
  likedActService(postId, flag)
);
const removeSave = (postId) => {
  return async (dispatch) => {
    await removeSaveService(postId);
    dispatch({
      type: FORUM_REMOVE_ARCHIVE,
      postId,
    });
  };
};
const changeReduxState = (name, value) => {
  return (dispatch) => {
    dispatch({
      type: FORUM_ON_CHANGE_STATE,
      name,
      value,
    });
  };
};

const clearForum = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_FORUM,
    });
  };
};
const deleteItem = createActionThunk(FORUM_DELETE_POST, (postId) =>
  deletePostService(postId)
);
const selectForEdit = (postId, typeOfSelect) => {
  return async (dispatch) => {
    dispatch({
      type: FORUM_SELECT_FOR_EDIT_POST,
      postId,
      typeOfSelect,
    });
  };
};
const doArchive = createActionThunk(FORUM_DO_ARCHIVE, (data) =>
  doArchiveService(data)
);
const EditForum = createActionThunk(FORUM_INSERT, (inputs, isdraft = false) =>
  editForum(inputs, isdraft)
);
const forumSinglInitialization = createActionThunk(
  FORUM_SINGLE_INITIALIZATION,
  (postId) => singlePostGet(postId)
);
const cancelPost = () => {
  return async (dispatch) => {
    dispatch({
      type: FORUM_CANCEL_POST,
    });
  };
};
const forumLoadMore = createActionThunk(
  FORUM_LOAD_MORE,
  (symptomId, sortBy, keyWord, userId, draft, lang, page) =>
    loadMorePost(symptomId, sortBy, keyWord, userId, draft, lang, page)
);

const archiveFiltersChange = createActionThunk(
  ON_CHANGE_ARCHIVE_FILTERS,
  async (name, value) => {
    let user = JSON.parse(localStorage.getItem("user"));
    return {
      name,
      value,
      userLang: user.lang,
    };
  }
);

const onSearchPosts = (search, filters, userId = undefined, draft = false, pageMode = false, pageName = '') => {
  return async (dispatch) => {
    let user = JSON.parse(localStorage.getItem('user'));
    filters["search"] = search;

    // Dispatch immediate search action
    dispatch({ type: ON_SEARCH_POSTS, value: search });

    // Clear previous timeout if it exists
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    // Set a delay before dispatching the actual API call
    typingTimeout = setTimeout(async () => {
      try {
        // Dispatch action to indicate loading has started
        dispatch({ type: getStarted(ON_CHANGE_FORUM_FILTERS) });
        let data = await getList(
          filters.symptom,
          filters.sortBy,
          filters.search,
          userId,
          draft,
          filters.lang,
        );

        // Dispatch success action with the retrieved data
        dispatch({
          type: getSucceeded(ON_CHANGE_FORUM_FILTERS),
          payload: {
            name: 'search',
            value: search,
            data: data,
            pageName,
            userLang: user.lang,
            pageMode,
          },
        });
      } catch (error) {
        // Handle error if necessary
        console.error(error);
      } finally {
        // Dispatch action to indicate loading has ended
        dispatch({ type: getEnded(ON_CHANGE_FORUM_FILTERS) });
      }
    }, 1000); // 1-second delay
  };
};

export default {
  forumSinglInitialization,
  cancelPost,
  removeSave,
  forumLoadMore,
  forumInitialization,
  forumMeInitialization,
  forumArchiveInitialization,
  insertForum,
  onChangeFilters,
  likedAct,
  changeReduxState,
  deleteItem,
  reGetPosts,
  selectForEdit,
  EditForum,
  doArchive,
  archiveFiltersChange,
  onSearchPosts,
  clearForum,
};



// WEBPACK FOOTER //
// ./src/actions/forumActions.js